
import { Component, Prop, VModel, Vue } from 'vue-property-decorator';

@Component
export default class KeyInput extends Vue {
    @VModel() input!: string;
    @Prop() length!: number;
    @Prop() title!: string;
    @Prop({ default: false }) inactive!: boolean;
    @Prop({ default: false }) fromRight!: boolean;
    @Prop({ default: false }) secret!: boolean;
    @Prop({ default: false }) disabled!: boolean;

    protected onActiveClick(): void {
        if (!this.disabled) {
            this.$emit('activate');
        }
    }

    protected getCharAtPosition(position: number) {
        if (this.fromRight) {
            position = this.input.length - this.length + position; // Adjusted position to count from the right edge
            if (position >= 0 && position < this.input.length) {
                return this.input.slice(position, position + 1);
            }
        } else {
            if (this.input.length > position) {
                return this.input.slice(position, position + 1);
            }
        }
        return '-';
    }
}
